import React from 'react';
import Notification from 'syngenta-digital-cropwise-react-ui-kit/dist/components/notification';

export interface ListPriceNotificationOptions {
  productName?: string;
  count?: number;
}

/**
 * Warns that the invoice saved but the list price update did not.
 *
 * Deliberately separate from `invoiceNotification`: that reports "Unable to
 * save Invoice", which would be untrue here and far more alarming than what
 * actually happened. Deliberately a warning rather than an error, for the same
 * reason — nothing the user entered has been lost.
 */
const listPriceNotification = (options?: ListPriceNotificationOptions) => {
  const { productName, count = 1 } = options || {};

  let description: string;
  if (count === 1 && productName) {
    description = `The list price for ${productName} could not be updated. The Invoice itself was successfully saved. You can update ${productName}’s list price through the Products page.`;
  } else if (count === 1) {
    description =
      'The list price for the selected product could not be updated. The Invoice itself was successfully saved. You can update the product’s list price through the Products page.';
  } else {
    description =
      'The list prices for your products could not be saved. The Invoice itself was successfully saved. You can update a product’s list price through the Products page.';
  }

  Notification.warning({
    // @ts-ignore — the kit types `message` as string, but every caller in this
    // repo passes a node for the bolded title.
    message: (
      <span className="font-semibold">Unable to update list price.</span>
    ),
    description,
    placement: 'topRight',
    duration: 8
  });
};

export default listPriceNotification;
